import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import globalMU from "globalMU"
import { resetAll } from "./actions/resetAll"

const initialState: {[funcionalidadeAcao: string]: boolean} = {}

export const permissoesSlice = createSlice({
    name: "permissoes",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        inserirOuAtualizar: (permissoes, action: PayloadAction<{funcionalidade: string, acao: string, permitido: boolean}>) => {
            const permissoes_ = {...permissoes}
            const chave = action.payload.funcionalidade + (globalMU.isNullOrEmpty(action.payload.acao) ? '' : `;${action.payload.acao}`)
            permissoes_[chave] = action.payload.permitido

            return permissoes_
        },
        remover: (permissoes, action: PayloadAction<{funcionalidade: string, acao: string}>) => {
            const permissoes_ = {...permissoes}
            const chave = action.payload.funcionalidade + (globalMU.isNullOrEmpty(action.payload.acao) ? '' : `;${action.payload.acao}`)
            delete permissoes_[chave]

            return permissoes_
        }
    }
})

export default permissoesSlice.reducer

export const {
    inserirOuAtualizar,
    remover
} : {
    inserirOuAtualizar: ActionType<{funcionalidade: string, acao: string, permitido: boolean}>,
    remover: ActionType<{funcionalidade: string, acao: string}>
} = permissoesSlice.actions